import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function getObatByRegister(registerId: string | number) {
  const response = await http
    .getData(`/obat/register/${registerId}/transaksi-obat`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getLabByRegister(registerId: string | number) {
  const response = await http
    .getData(`/lab/register/${registerId}/lab`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getRadiologiByRegister(registerId: string | number) {
  const response = await http
    .getData(`/radiologi/register/${registerId}/radiologi`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getRecentLabResult(unitId: string) {
  const response = await http
    .getData(`/lab/result?unit=${unitId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  getObatByRegister,
  getLabByRegister,
  getRadiologiByRegister,
  getRecentLabResult
};
